import { Col, Row } from 'antd';
import { useState } from 'react';
import { useAccountPopup } from '../AccountPopup';
import { use_ANNOUNCEMENTINFORMATION } from './data';
import './index.scss';
export const useBaseInfo = ({ details = {} }: any) => {
  const [open, setOpen] = useState(false);
  const ANNOUNCEMENTINFORMATION = use_ANNOUNCEMENTINFORMATION();
  const handleCancel = () => {
    setOpen(false);
  };
  const { accountComponent } = useAccountPopup({ handleCancel, open, details });

  const handleDisplayAccount = () => {
    setOpen(true);
  };

  const baseInfoComponent = (
    <>
      <Row gutter={[18, 18]}>
        {ANNOUNCEMENTINFORMATION.map((x: any, index) => {
          return (
            <Col span={10} key={index} className="pc-info-flex">
              <div className="pc-info-label">{x.label} :</div>
              <div>{x.render ? x.render(details) : details[x.key] || ''}</div>
            </Col>
          );
        })}
        <Col span={12} className="pc-info-flex">
          <div className="pc-info-label">公告链接 :</div>
          <div>
            <a
              href={details.noticeLink}
              target="_blank"
              className="pc-info-link"
            >
              Link{' '}
            </a>
            &nbsp;
            <span className="pc-info-password" onClick={handleDisplayAccount}>
              查看千里马账号密码
            </span>
          </div>
        </Col>
      </Row>
      {accountComponent}
    </>
  );
  return {
    baseInfoComponent
  };
};
